import React from "react";

const Input = ({
  action,
  error,
  hint,
  label,
  name,
  rightElement,
  wrapperClassName = "",
  ...props
}) => {
  return (
    <div className={wrapperClassName}>
      {label && (
        <div className="mb-3 flex items-center justify-between gap-4">
          <label
            htmlFor={name}
            className="block text-[12px] font-bold uppercase tracking-[0.02em] text-[#111111]"
          >
            {label}
          </label>
          {action}
        </div>
      )}

      <div className="relative">
        <input
          id={name}
          name={name}
          className={`h-12 w-full rounded-[10px] border border-transparent bg-[#dfe3e6] px-4 text-[14px] text-[#111111] outline-none placeholder:text-[#6b7280] transition focus:border-black ${
            rightElement ? "pr-14" : ""
          }`}
          {...props}
        />
        {rightElement && (
          <div className="absolute right-4 top-1/2 -translate-y-1/2">
            {rightElement}
          </div>
        )}
      </div>

      {hint && <p className="mt-3 text-[12px] text-[#374151]">{hint}</p>}
      {error && <p className="mt-2 text-[12px] text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
